import toast from 'react-hot-toast'
import {
    get,
    unsecurePost
} from '../helpers/apiHelper.ts'
import authStore from '../store/authStore.ts'
import controlStore from '../store/controlStore.ts'
import dataStore from '../store/dataStore'
import { ACCOUNT_DATA_URL, APPLICATION_DATA_URL, V2_LOGIN_URL, MAP_DATA_URL } from '../helpers/urls.ts'

export const loadLoginData = async (token: string, userDetails: any, _cancelToken?: any): Promise<void> => {
    if (!(token && userDetails)) return

    try {
        authStore.getState().setToken(token)
        authStore.getState().setTimezone(userDetails.timezone)

        // Fire all three requests in parallel. None are cancellable because cancelling
        // (from LoginForm unmount / StrictMode remount) leaves the app as an empty shell.
        const mapPromise = get(MAP_DATA_URL)
        const accountPromise = get(ACCOUNT_DATA_URL)
        const applicationPromise = get(APPLICATION_DATA_URL)

        // Fire-and-forget: these populate their stores when they arrive. Swallow errors
        // here so they don't become unhandled rejections — apiHelper already logs them.
        void accountPromise
            .then(res => { if (res?.data) dataStore.getState().loadAccountData(res.data) })
            .catch(() => { /* logged by apiHelper */ })
        void applicationPromise
            .then(res => { if (res?.data) dataStore.getState().loadApplicationData(res.data) })
            .catch(() => { /* logged by apiHelper */ })

        const mapData = await mapPromise
        if (mapData) {
            dataStore.getState().loadMapData(mapData.data)
        }
        // If mapData is null, apiHelper.get already handled/logged the failure.
        // Stay quiet — the caller decides whether to navigate.
    } catch (e: any) {
        // Ignore cancellations (e.g., StrictMode remount or navigation away)
        // axios.isCancel is the canonical check, but we also check for the Cancel error shape.
        if (e?.__CANCEL__ || e?.message === 'canceled' || e?.name === 'CanceledError') {
            return
        }
        if (e?.response?.data?.message === 'jwt expired') {
            toast.error('Saved credentials expired. Please log in again.')
        } else {
            toast.error('Server unavailable')
        }
        controlStore.getState().setShowLoader(false)
        throw e
    }
}

export const loginHandler = async (formData: any): Promise<string> => {
    let route = '/'
    try {
        const result: any = await unsecurePost(V2_LOGIN_URL, formData)
        if (result?.data?.status) {
            await loadLoginData(result.data.token, result.data.userDetails)
            if (formData.rememberMe) {
                localStorage.setItem('gibi', JSON.stringify({ t: result.data.token }))
                localStorage.setItem('gibiUser', JSON.stringify(result.data.userDetails))
            }
            route = '/map'
        } else {
            toast.error(result?.response?.data?.message || 'Login error')
        }
    } catch (e) {
        toast.error('Login error')
    }
    return route
}
